import React from 'react';

const digits = (v) => String(v || '').replace(/\D/g, '');

export function RegistryLink({ abn, nzbn, prefix = false, className = '', style = {} }) {
  let a = abn, n = nzbn;
  if (a && !n && digits(a).length === 13) { n = a; a = null; }
  const value = a || n;
  if (!value) return <span className={className} style={style} data-testid="registry-link-none">{prefix ? 'No ABN' : '—'}</span>;
  const isAbn = !!a;
  return (
    <span data-testid="registry-link" className={className} style={{ color: '#5C6B7A', ...style }}>
      {prefix ? `${isAbn ? 'ABN' : 'NZBN'}: ${value}` : value}
    </span>
  );
}
